import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import AutomationRulesManager from '@admin/components/governance/AutomationRulesManager';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import OrgNoAccessBanner from '@shared/components/organization/banners/OrgNoAccessBanner';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgGovernancePage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isLoading, canManageGovernance } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;

    return (
        <OrgPageTemplate>
            <PageHeader
                title={t('common:organization.governance.orgTitle', { value: currentOrg.name })}
                description={t('common:organization.governance.description')}
                items={items}
            />
            {currentOrg.isEmployeeAccess && canManageGovernance ? (
                <AutomationRulesManager organizationId={currentOrg.id} />
            ) : (
                <OrgNoAccessBanner />
            )}
        </OrgPageTemplate>
    );
}
